import { submitReviewUrl } from '../Reviews/constants';
/*
 * Return a tracking component friendly products array from shopify item array
 * @param {Array} array of product item objects
 * @return {Array} array of formatted products objects
 */

export var itemsToProducts = function itemsToProducts(items) {
  return items.map(function (_ref) {
    var productTitle = _ref.title,
        src = _ref.image,
        shopifyId = _ref.shopifyId,
        variantId = _ref.variantId,
        subtitle = _ref.subtitle;
    var connectStr = ' — ';
    var titleArray = productTitle.split(connectStr);
    var title = titleArray && titleArray.length > 0 ? titleArray[0] : productTitle;
    var newSubtitle = titleArray && titleArray.length > 1 ? titleArray[1].replace(' / ', connectStr) : '';
    var image = src ? {
      alt: title,
      src: src
    } : false;
    var reviewLink = shopifyId || variantId ? submitReviewUrl(shopifyId, variantId) : null;
    return {
      image: image,
      title: title,
      reviewLink: reviewLink,
      subtitle: subtitle || newSubtitle,
      variantId: variantId
    };
  }).sort(function (item1, item2) {
    return item1.title > item2.title ? 1 : -1;
  });
};
/*
 * Return a tracking component friendly products array from shopify line item array
 * @param {Array} array of line item objects
 * @return {Array} array of formatted products objects
 */

export var lineItemsToItems = function lineItemsToItems(items) {
  return items.map(function (_ref2) {
    var product = _ref2.product,
        sku = _ref2.sku,
        title = _ref2.title,
        variant = _ref2.variant,
        id = _ref2.variant_id;
    var images = product && product.images ? product.images : [];
    var image = false;
    images.forEach(function (_ref3) {
      var src = _ref3.src,
          ids = _ref3.variant_ids;
      var foundId = ids.find(function (imageVariantId) {
        return id === imageVariantId;
      });

      if (foundId) {
        image = src;
      }
    });
    var shopifyId = product.id;
    var subtitle = variant ? "".concat(variant.option1, " \u2014 ").concat(variant.option2) : '';
    return {
      image: image,
      shopifyId: shopifyId,
      variantId: id,
      subtitle: subtitle,
      title: product !== null && product !== void 0 && product.title ? product.title : title,
      sku: sku
    };
  }).sort(function (item1, item2) {
    return item1.title > item2.title ? 1 : -1;
  });
};